import axios from "axios"
import { GenerarFicheroModelo180CommandProps } from "./Commands/GenerarFicheroModelo180Command"
import { GenerarFicheroModelo190CommandProps } from "./Commands/GenerarFicheroModelo190Command"
import { GenerarFicheroModelo303CommandProps } from "./Commands/GenerarFicheroModelo303Command"
import { GenerarFicheroModelo347CommandProps } from "./Commands/GenerarFicheroModelo347Command"
import { GenerarFicheroModelo349CommandProps } from "./Commands/GenerarFicheroModelo349Command"
import { GenerarFicheroModelo390CommandProps } from "./Commands/GenerarFicheroModelo390Command"
import { GetDatosDeclaracionModelo190DtoProps } from "./DTOs/GetDatosDeclaracionModelo190Dto"
import { GetDatosDeclaracionModelo303DtoProps } from "./DTOs/GetDatosDeclaracionModelo303Dto"
import { GetDatosDeclaracionModelo347DtoProps } from "./DTOs/GetDatosDeclaracionModelo347Dto"
import { GetDatosDeclaracionModelo390DtoProps } from "./DTOs/GetDatosDeclaracionModelo390Dto"
import { GetDatosDeclaracionModelo349DtoProps } from "./DTOs/GetDatosDeclaracioneModelo349Dto"
import { GetDatosDeclaracionModelo180DtoProps } from "./DTOs/GetDeclaracionModelo180Dto"
import { PeriodoDeclaracionModeloEnumType } from "./Types/PeriodoDeclaracionModeloEnum"

export interface queryParamsGetDeclaracionModelo {
  Anyo: number
  PeriodoDeclaracion?: PeriodoDeclaracionModeloEnumType | null
}
export async function getDeclaracionModelo180(
  queryParams: queryParamsGetDeclaracionModelo
): Promise<GetDatosDeclaracionModelo180DtoProps> {
  const { data } = await axios.get("/DeclaracionModelo/180", {
    params: queryParams,
  })
  return data
}
export async function postDeclaracionModelo180(
  body: GenerarFicheroModelo180CommandProps
): Promise<Blob> {
  const { data } = await axios.post("/DeclaracionModelo/180/fichero", body, {
    responseType: "blob",
  })
  return data
}

export async function getDeclaracionModelo190(
  queryParams: queryParamsGetDeclaracionModelo
): Promise<GetDatosDeclaracionModelo190DtoProps> {
  const { data } = await axios.get("/DeclaracionModelo/190", {
    params: queryParams,
  })
  return data
}
export async function postDeclaracionModelo190(
  body: GenerarFicheroModelo190CommandProps
): Promise<Blob> {
  const { data } = await axios.post("/DeclaracionModelo/190/fichero", body, {
    responseType: "blob",
  })
  return data
}

export async function getDeclaracionModelo303(
  queryParams: queryParamsGetDeclaracionModelo
): Promise<GetDatosDeclaracionModelo303DtoProps> {
  const { data } = await axios.get("/DeclaracionModelo/303", {
    params: queryParams,
  })
  return data
}
export async function postDeclaracionModelo303(
  body: GenerarFicheroModelo303CommandProps
): Promise<Blob> {
  const { data } = await axios.post("/DeclaracionModelo/303/fichero", body, {
    responseType: "blob",
  })
  return data
}

export async function getDeclaracionModelo347(
  queryParams: queryParamsGetDeclaracionModelo
): Promise<GetDatosDeclaracionModelo347DtoProps> {
  const { data } = await axios.get("/DeclaracionModelo/347", {
    params: queryParams,
  })
  return data
}

export async function postDeclaracionModelo347(
  body: GenerarFicheroModelo347CommandProps
): Promise<Blob> {
  const { data } = await axios.post("/DeclaracionModelo/347/fichero", body, {
    responseType: "blob",
  })
  return data
}

export async function getDeclaracionModelo349(
  queryParams: queryParamsGetDeclaracionModelo
): Promise<GetDatosDeclaracionModelo349DtoProps> {
  const { data } = await axios.get("/DeclaracionModelo/349", {
    params: queryParams,
  })
  return data
}
export async function postDeclaracionModelo349(
  body: GenerarFicheroModelo349CommandProps
): Promise<Blob> {
  const { data } = await axios.post("/DeclaracionModelo/349/fichero", body, {
    responseType: "blob",
  })
  return data
}

export async function getDeclaracionModelo390(
  queryParams: queryParamsGetDeclaracionModelo
): Promise<GetDatosDeclaracionModelo390DtoProps> {
  const { data } = await axios.get("/DeclaracionModelo/390", {
    params: queryParams,
  })
  return data
}
export async function postDeclaracionModelo390(
  body: GenerarFicheroModelo390CommandProps
): Promise<Blob> {
  const { data } = await axios.post("/DeclaracionModelo/390/fichero", body, {
    responseType: "blob",
  })
  return data
}
